module.exports = "/fonts/Roboto-Regular.svg";